import React from "react";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { audiosAssets } from "../../assets/audio";

export const PanelInstrucionHands = ({ img = "", text = "", buttonText = "Entendido", action = () => { } }) => {
	return (
		<div className="fixed  z-30 bg-[#00000074] w-full h-full flex justify-center items-center">
			<div className="bg-white w-[296px] md:w-[464px] h-[269px] md:h-[384px] rounded-[16px] md:rounded-[32px] xl:w-[550px] xl:h-[400px] p-4 md:p-6 flex flex-col">
				<div className="h-[200px] md:h-[270px] xl:h-[350px] overflow-hidden rounded-[8px] md:rounded-[16px] relative">
					<div className="absolute z-20 w-full h-[40px] md:h-[37px] overflow-hidden bottom-0 bg-[#282828] flex justify-center items-center text-center">
						<p className="text-white text-[12px] md:text-[12px] xl:text-[16px] font-bold">{text}</p>
					</div>
					<div className="h-full ">
						<img className="h-full w-full object-cover" src={img} alt="info" />
					</div>
				</div>
				<div className="h-[55px] md:h-[65px] xl:h-[80px]  flex justify-center items-center pt-2">
					<button onClick={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
						action()
					}} className="boxShadowButtons font-bold bg-[#FFC427] text-white w-[136px] md:w-[256px] py-2 rounded-xl">
						{buttonText}
					</button>
				</div>
			</div>
		</div>
	);
};
